import bridge from '@/utils/bridge';
import { getRecentContacts } from '@/utils/ContactUtils';
import store from '@/store';
import ContactProxy from '@/Proxies/ContactProxy';
import { Actions } from '@/actions/restricted';
import { getCounter } from './utilities';

class RecentContactsProxy {
  counter = getCounter();

  contactProxySubscriptions = {};

  subscribedIds = {};

  constructor() {
    bridge.subscribe('/contact/recent', this.onRecent.bind(this));
  }

  getCurrentState = () => {
    const state = store.getState();
    const recentContacts = state.restricted.contact.recent_contacts_meta_proxy;
    if (!recentContacts) {
      return {};
    }

    return recentContacts;
  };

  setRecentsInStore(ownerGuid, contactIds) {
    store.dispatch(
      Actions.recent_contacts_meta_proxy({ [ownerGuid]: contactIds })
    );
    this.contactProxySubscriptions[ownerGuid].update(ownerGuid, contactIds);
  }

  onRecent(contact) {
    const recentContacts = this.getCurrentState();
    const { ownerGuid } = contact;
    if (!recentContacts[ownerGuid]) {
      return;
    }
    const recentsSet = new Set([...recentContacts[ownerGuid]]);
    if (contact.isRecent) {
      recentsSet.add(contact.jid);
    } else {
      recentsSet.delete(contact.jid);
    }
    this.setRecentsInStore(ownerGuid, Array.from(recentsSet));
  }

  subscribe(ownerGuid) {
    const id = this.counter.next().value;

    if (!this.subscribedIds[ownerGuid]) {
      this.subscribedIds[ownerGuid] = [];
    }
    if (this.subscribedIds[ownerGuid].length === 0) {
      getRecentContacts(ownerGuid).then((contacts) => {
        const contactsSet = new Set();
        for (let i = 0; i < contacts.length; i += 1) {
          contactsSet.add(contacts[i].jid);
        }
        this.setRecentsInStore(ownerGuid, Array.from(contactsSet));
      });
    }
    this.subscribedIds[ownerGuid].push(id);

    if (!this.contactProxySubscriptions[ownerGuid]) {
      this.contactProxySubscriptions[ownerGuid] = ContactProxy.subscribe(
        ownerGuid,
        []
      );
    }
    return { unsubscribe: this.unsubscribe.bind(this, ownerGuid, id) };
  }

  unsubscribe(ownerGuid, id) {
    if (!ownerGuid || !id) {
      return;
    }
    const subscriptions = this.subscribedIds[ownerGuid];
    if (subscriptions.length > 0) {
      const idx = subscriptions.indexOf(id);
      subscriptions.splice(idx, 1);
    }
    if (subscriptions.length < 1) {
      this.setRecentsInStore(ownerGuid, []);
      this.contactProxySubscriptions[ownerGuid].unsubscribe();
    }
  }
}

export default new RecentContactsProxy();
